import * as React from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

export interface SearchInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  containerClassName?: string;
  iconSize?: number;
}

const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  ({ className, containerClassName, iconSize = 18, ...props }, ref) => (
    <div className={cn('relative w-full', containerClassName)}>
      <Search
        className="absolute left-3 top-1/2 -translate-y-1/2 text-[#87ADD4] pointer-events-none"
        size={iconSize}
      />
      <Input ref={ref} type="text" className={cn('pl-11 md:pl-10', className)} {...props} />
    </div>
  )
);
SearchInput.displayName = 'SearchInput';

export { SearchInput };
